import React from 'react'

const findDemandForecastMaxValue = (data) => {
    const arr = [
        checkEmpty(data?.demand),
        checkEmpty(data?.forecast),
      ];
    
      function checkEmpty(arr) {
        if (arr === null) {
          return [];
        }
        if (Object.entries(arr).length > 0) {
          return arr.filter(Boolean);
        } else {
          return [];
        }
      }
    
      function getMax(a) {
        return Math.max(...a.map((e) => (Array.isArray(e) ? getMax(e) : e)));
      }
      return getMax(arr);
    };

export default findDemandForecastMaxValue